import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { get, del } from '../client';
import type { Memory } from '@formency/shared';

const MEMORY_KEY = ['f', 'memories'] as const;

export function useMemories() {
  return useQuery({
    queryKey: MEMORY_KEY,
    queryFn: () => get<Memory[]>('/me/memories'),
    staleTime: 5 * 60 * 1000,
  });
}

export function useDeleteMemory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (memoryId: string) => del(`/me/memories/${memoryId}`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: MEMORY_KEY });
    },
  });
}
